<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">ОБЩИ УСЛОВИЯ ЗА ПОЛЗВАНЕ НА УСЛУГАТА KeepYouFit</h1>
      <span class="is-size-7">
        <p class="is-size-6">I. ОБЩИ РАЗПОРЕДБИ</p>
        <p>
        Настоящите Общи условия при регистрация, използване на услугата KeepYouFit уреждат отношенията между Business Fleet s.r.o., Lidická 700/19 | Veveří, 602 00 Brno | Czech Republic, USt-IdNr: CZ24814776. и всяко лице използващо Услугата (наричано по-долу за краткост ПОТРЕБИТЕЛ), което се регистрира на Интернет страницата http://bg.keepyou.fit/#/ и/или използва услугите на интернет страниците http://bg.keepyou.fit/#/
        </p>
        <p class="is-size-6">II. Заявяване на услуги.</p>
        <p>
        За да ползва услугите на Сайта и Приложението, Потребителят трябва да се регистрира в Сайта
        или в Приложението или да изрази желание за ползването им.
        В случаите, в които като потребител се регистрира непълнолетно лице, същото декларира и
        съгласието на своите родители или попечители с настоящите Общи условия. В случаите на
        регистрация на лице под 14-годишна възраст, заявлението за съгласие с Общите условия се
        извършва от родител или настойник на същото.
        Съгласяване с Общите условия. Потребителят изразява волята си за съгласие с настоящите Общи
        условия. Съгласието, изразено при условията на предходното изречение, представлява
        електронно изявление, с което Потребителят декларира че е запознат с настоящите Общи
        условия, съгласен е с тях и се задължава да ги спазва.
        При ползване на Услугата, Потребителят се съгласява с Общите условия и/или при сваляне на
        Приложението на мобилното си устройство.
        Избиране на абонаментен план. Потребителят избира конкретен абонаментен план, който
        заплаща.</p>
        <p class="is-size-6">III. Цени и заплащане.</p>
        <p>
        Услугата предлага основен начин на разплащане: чрез DCB (плащане, което удържа сумата от
        вашата мобилна телефонна сметка).
        Суми за направени плащания не се възстановяват.
        Цена на абонамент за 7 поредни дни: 6,01 BGN/седмица лева с ДДС, плащане, което удържа
        сумата от вашата мобилна телефонна сметка
        Услугата е валидна за мобилните оператори: Vivacom, М-Тел и Теленор чрез Wi-Fi. За целта се
        въвежда мобилния телефонен номер (можете да го въведете например: 024928370 / 024487202 или +3524928370) в
        специално поле. Натиска се бутон &quot;Абонирайте се“ или „Плати със сметката на мобилния си
        телефон“, след което се получава SMS от кратък номер с код за достъп, който се въвежда в
        съответното поле и така се получава достъп до Услугата.
        Услугата е валидна за мобилните оператори: Vivacom, М-Тел и Теленор, чрез мобилната мрежа.
        За Мтел, потребителя трябва да се съгласи с общите условия с натискане и отбелязване на
        отметка. След отбелязването с отметка при Общите условия трябва да натисне върху бутона &quot;
        Плати със сметката на мобилния си телефон &quot; след което ще бъде пренасочен към нова страница,
        където за пореден път трябва да потвърди, че е съгласен да бъде абониран за услугата с
        натискането на бутона &quot;ОК&quot;. За Telenor, потребителя трябва да се съгласи с общите условия с
        натискане и отбелязване на отметка. След това трябва да натисне върху бутона &quot; Абонирайте се &quot;,
        за да се абонира за услугата. Цената на услугата е указана над бутоните „Плати със сметката на
        мобилния си телефон“ или &quot;Абонирайте се“ 6,01 BGN/седмица. лв. с ДДС, което дава възможност
        потребителите да бъдат информирани относно цената на услугата, преди тарифиране.
        С извършване на плащането Потребителят изразява своето изрично съгласие, че желае да
        получи достъп до заявеното съдържание. Потребителят потвърждава, че е съгласен със и знае, че
        с извършване на плащането от страна на Потребителя и получаването на достъп до заявеното
        цифрово съдържание .
        Активиране на Услугата. Услугата се активира след потвърждаване на плащането .</p>
        <p class="is-size-6">IV. Права и задължения на Доставчика</p>
        <p>
        Доставчикът се задължава да опазва предоставената от Потребителя информация при
        регистрацията му в съответствие с правилата на Закона за защита на личните данни.
        Доставчикът не носи отговорност, ако Потребителят не изпълнява правилно зададените
        указания за достъп до съответната платежна система или ако вината за недоставяне на услугата е
        извън компетентността на Доставчика.

        Доставчикът си запазва правото да прекрати незабавно и безусловно достъпа до услугата на
        Потребител, който осъществява опит за неправомерно въздействие от съдържанието на Услугата.
        Сайтът и Приложението може да съдържат линкове към други страници или интернет ресурси.
        Доставчикът не контролира и не е отговорен за съдържанието, продуктите, услугите или
        информацията, намиращи се в тези линкове.</p>
        <p class="is-size-6">V. Права и задължения на Потребителя</p>
        <p>
        Потребителят се задължава да упражнява правата си за ползване на услугите, спазвайки
        приложимите нормативни актове, настоящите Общи условия и инструкциите за ползване.
        Потребителят носи пълната отговорност за опазване на своите e-mail и парола, както и за всички
        действия, които се извършват от него или от трето лице чрез използване на неговите данни.
        Потребителят се задължава да не записва, възпроизвежда, тиражира, публикува или
        разпространява по какъвто и да било начин съдържанието, до което му е предоставен достъп.
        Доставчикът не носи отговорност за неправилно използване на Приложението.
        Всякакво публично показване на съдържанието с търговска или друга цел различна от личното
        ползване е забранена.</p>
        <p class="is-size-6">VI. Рекламации</p>
        <p>
        Доставчикът не носи отговорност при софтуерни или хардуерни проблеми с крайното
        устройство на Потребителя, отказ на оборудване при Потребителя, неправилно въвеждане на
        кодове за достъп, неизправен хардуер или софтуер или прекъсване на интернет връзката при
        Потребителя, проблеми на интернет доставчика, или в други случаи, независещи от Доставчика.
        Когато Доставчикът имплементира подобрения и промени в услугата, то същите не могат да
        бъдат разглеждани като основание за рекламация.
        Доставчикът не носи отговорност за вреди, причинени от Клиента на трети лица.
        Доставчикът не носи отговорност за имуществени или неимуществени вреди, изразяващи се в
        пропуснати ползи или претърпени вреди, причинени на Клиента в процеса на използване или
        неизползване на Услугата.
        Доставчикът не дължи обезщетение при вина на някой от подизпълнителите на услугата.

        Информацията и личните данни, която потребителя доброволно предоставя при и по повод
        използване на услугата, дава право на доставчика да ги използва в рамките на своите собствени
        проекти.</p>
        <p class="is-size-6">VII. Отказ</p>
        <p>
        Правото на отказ от страна на Потребителя може да се откаже от абонамента като изпрати СМС с
        текст STOP FIT на кратък номер 14703 (Съобщението се таксува според тарифния Ви план), или
        като посети следния адрес: http://bg.keepyou.fit/#/deactivation</p>
      </span>      
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Terms',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/BG/Terms.vue